// extracted by mini-css-extract-plugin
export default {"benefits":"TeamAcceptJoinBenefits_benefits__29dR9","check":"TeamAcceptJoinBenefits_check__vAw+p"};